import { Navigate } from "react-router";
import { useGetCordwoodHistoryQuery } from "../../../apis/CordwoodHistory.api";
import { PrimaryCordwoodHistory, CordwoodHistory } from "../../../types/models/CordwoodHistory";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const CordwoodHistoryScoped = () => {
    const {
        data,
    } = useGetCordwoodHistoryQuery(PrimaryCordwoodHistory.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/cordwood-histories/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default CordwoodHistoryScoped;
